import { useMemo } from 'react';
import { HomeVehicleMosaic } from './HomeVehicleMosaic';

interface HomeSeminovosProps {
  vehicles: any[];
  store: any;
}

export function HomeSeminovos({ vehicles, store }: HomeSeminovosProps) {
  const show = !!store?.ad?.showUsed;

  const pool = useMemo(
    () =>
      vehicles
        .filter((v) => !v.isZeroKm && v.mileage > 0 && !v.armored)
        .slice(0, 20),
    [vehicles]
  );

  if (!show || pool.length === 0) return null;

  return (
    <HomeVehicleMosaic
      id="seminovos"
      title="Seminovos"
      lead="Seleção revisada, com procedência e condições pensadas para o seu próximo carro."
      vehicles={pool}
      viewAllHref="/estoque?type=seminovo"
      viewAllLabel="Ver todos os seminovos"
      nextLabel="Próximos seminovos"
    />
  );
}
